import store from '../store'
const getHref=function (){
    let href=localStorage.getItem("guanai_href");
    localStorage.removeItem("guanai_href");
    return href;
}
const getLogout=function(){
    let logout=localStorage.getItem("guanai_logout");
    return logout;
}
const wxLogin=function(e){
    if(e){
        localStorage.setItem("guanai_href",e);
    }else{
        localStorage.removeItem("guanai_href");
    }
    // window.location.href="http://insure2.yklmartspace.com/public/api/home/Wechat/wxLogin";
    window.location.href=store.state.baseURL+'Wechat/wxLogin';
}
export{
    getHref,
    wxLogin,
    getLogout
}


// WEBPACK FOOTER //
// ./src/utils/util.js